import { createRemoteJWKSet, jwtVerify } from 'jose';

const AUTH0_HOST = process.env.REACT_APP_AUTH0_DOMAIN ?? '';
const AUTH0_ISSUER = `https://${AUTH0_HOST}/`;
const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE ?? '';

const JWKS_NOT_INITIALIZED_ERROR =
  'JWKS is not initialized (missing REACT_APP_AUTH0_DOMAIN)';

const JWKS = AUTH0_HOST
  ? createRemoteJWKSet(
      new URL(`https://${AUTH0_HOST}/.well-known/jwks.json`)
    )
  : null;

export const verifyApiAccessToken = async (token: string): Promise<boolean> => {
  if (!JWKS) {
    throw new Error(JWKS_NOT_INITIALIZED_ERROR);
  }

  await jwtVerify(token, JWKS, {
    issuer: AUTH0_ISSUER,
    audience: AUTH0_AUDIENCE
  });

  return true;
};
